import dayjs from "dayjs";
import { PRESET_SHORTCUT_IDS, SHORTCUTS } from "../RangeCalendar/constants";

export const getRangeByShortcut = (shortcutId) => {
  const today = dayjs().startOf("day");

  switch (shortcutId) {
    case "today":
      return { fromDate: today, toDate: today };
    case "yesterday": {
      const yesterday = today.subtract(1, "day");
      return { fromDate: yesterday, toDate: yesterday };
    }
    case "last7Days":
      return { fromDate: today.subtract(6, "day"), toDate: today };
    case "last30Days":
      return { fromDate: today.subtract(29, "day"), toDate: today };
    case "thisMonth":
      return { fromDate: today.startOf("month"), toDate: today.endOf("month") };
    case "lastMonth": {
      const lastMonth = today.subtract(1, "month");
      return { fromDate: lastMonth.startOf("month"), toDate: lastMonth.endOf("month") };
    }
    case "thisQuarter": {
      const quarterStartMonth = Math.floor(today.month() / 3) * 3;
      const quarterStart = today.month(quarterStartMonth).startOf("month");
      return { fromDate: quarterStart, toDate: quarterStart.add(2, "month").endOf("month") };
    }
    case "lastQuarter": {
      const thisQuarterStartMonth = Math.floor(today.month() / 3) * 3;
      const thisQuarterStart = today.month(thisQuarterStartMonth).startOf("month");
      const lastQuarterStart = thisQuarterStart.subtract(3, "month");
      return { fromDate: lastQuarterStart, toDate: lastQuarterStart.add(2, "month").endOf("month") };
    }
    default:
      return { fromDate: today, toDate: today };
  }
};

export const normalizeValue = (value) => {
  const fromDate = value?.fromDate || value?.startDate;
  const toDate = value?.toDate || value?.endDate;
  const normalizedFromDate = fromDate ? dayjs(fromDate) : null;
  const normalizedToDate = toDate ? dayjs(toDate) : null;

  return {
    fromDate: normalizedFromDate?.isValid() ? normalizedFromDate.startOf("day") : null,
    toDate: normalizedToDate?.isValid() ? normalizedToDate.startOf("day") : null,
  };
};

const isSameDate = (a, b) => Boolean(a && b && dayjs(a).isSame(dayjs(b), "day"));

export const findShortcutByRange = (range) => {
  if (!range?.fromDate || !range?.toDate) return "custom";

  const matched = PRESET_SHORTCUT_IDS.find((shortcutId) => {
    const presetRange = getRangeByShortcut(shortcutId);
    return isSameDate(range.fromDate, presetRange.fromDate) && isSameDate(range.toDate, presetRange.toDate);
  });

  return matched || "custom";
};

export const getShortcutLabel = (shortcutId) => SHORTCUTS.find((item) => item.id === shortcutId)?.label;

export const getTriggerLabel = ({ label, selectedShortcut, committedRange }) => {
  if (selectedShortcut === "custom") {
    if (label) return label;

    const from = committedRange.fromDate;
    const to = committedRange.toDate || committedRange.fromDate;

    if (from && to) {
      const fromText = dayjs(from).format("DD/MM/YYYY");
      const toText = dayjs(to).format("DD/MM/YYYY");
      return `${fromText} - ${toText}`;
    }

    return "Tùy chỉnh";
  }

  return getShortcutLabel(selectedShortcut) || "Chọn ngày";
};

export const getInitialRange = (value) => {
  const externalRange = normalizeValue(value);
  if (externalRange.fromDate && externalRange.toDate) return externalRange;
  return { fromDate: null, toDate: null };
};
